import { useSnackbarStore } from '@/store/snackbar';

export function copyToClipboard(
  text: string,
  snackText = 'Copied to clipoard.',
) {
  navigator.clipboard.writeText(text);
  useSnackbarStore().push({
    text: snackText,
    closable: false,
    timeout: 2000,
  });
}
